<ng-container *ngIf="uszkodzenie">
    <app-strategia-podsumowania-uszkodzen
            [strategiaPodsumowaniaUszkodzenia]="getStrategiaPodsumowaniaUszkodzenia()"
            [zbiorUszkodzenPrzedmiotuId]="zbiorUszkodzenPrzedmiotuId"
            [zbiorUszkodzenId]="zbiorUszkodzenId"
            (usunUszkodzenieClick)="usunUszkodzenie($event)">
    </app-strategia-podsumowania-uszkodzen>
</ng-container>
